import React, { useEffect, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";
import AnimatedMainContainer from "../../../components/AnimatedMainContainer";
import {
  Container,
  TitleContainer,
  Title,
  ModalCreateAndEdit,
  FormItem,
  InputWrapper,
  IconWrapper,
  ButtonItens,
  StyledInput,
  SearchContainer,
  LinkButton,
  ModalDelete,
  ModalSubtitle,
  ButtonAdd,
  Horizontal,
  ButtonDelete,
  IconItensDiv,
  IconItensDivMobile,
} from "./styles";
import Badge from "../../../components/Badge";
import { GoBackContainer } from "../../Contracts/styles";
import { Space, Form, notification } from "antd";
import {
  ArrowLeftOutlined,
  DeleteOutlined,
  EditOutlined,
  EyeOutlined,
  PlusOutlined,
  RollbackOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import { FaRegSave, FaRegTrashAlt } from "react-icons/fa";
import api from "../../../service";
import Table from "../../../components/Table";
import { RiArrowGoBackLine } from "react-icons/ri";
import { useToast } from "../../../hooks/toast";

const StaffCategories = () => {
  const { token } = useSelector((state) => state.auth);
  const [form] = Form.useForm();
  const [ModalCreateAndEditVisible, setModalCreateAndEditVisible] =
    useState(false);
  const [ModalDeleteVisible, setModalDeleteVisible] = useState(false);
  const [isEditingCategory, setisEditingCategory] = useState(false);
  const intl = useIntl();
  const history = useHistory();
  const [viewSubCategories, setViewSubCategories] = useState(false);
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [loadingTable, setLoadingTable] = useState(false);
  const [selectId, setSelectId] = useState("");
  const [selectSubId, setSelectSubId] = useState("");

  const [selectTitle, setSelectTitle] = useState("");
  const [isEditingSubCategory, setisEditingSubCategory] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [buttonDisabled, setButtonDisabled] = useState(true);
  const [shouldGoBack, setShouldGoBack] = useState(false); // novo estado auxiliar
  const { addToast } = useToast();

  useEffect(() => {
    if (!viewSubCategories && shouldGoBack) {
      history.goBack();
      setShouldGoBack(false);
    }
  }, [viewSubCategories, shouldGoBack, history]);

  useEffect(() => {
    fetchCategories();
    if (viewSubCategories && selectId) {
      fetchSubCategories(selectId);
    }
  }, [viewSubCategories, selectId]);

  const fetchCategories = async () => {
    setLoadingTable(true);
    try {
      const response = await api.get("/service-categories", {
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
          Authorization: `Bearer ${token}`,
        },
        params: {
          page: 0,
          size: 100,
          sortBy: "id",
        },
      });

      setCategories(response.data.categoryOutPutList);
      form.setFieldsValue({
        title: response.data.categoryOutPutList.title,
      });
    } catch (err) {
      console.log(err);
    } finally {
      setLoadingTable(false);
    }
  };

  const insertCategory = async (values) => {
    try {
      await api.post(
        "/service-categories",
        {
          title: values.title,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      addToast({
        type: "success",
        title: intl.formatMessage({ id: "success" }),
        description: intl.formatMessage({ id: "success.category_creation" }),
      });
    } catch (err) {
      addToast({
        type: "error",
        title: intl.formatMessage({ id: "error" }),
        description: intl.formatMessage({
          id: "api.error." + err.response?.data?.description,
        }),
      });
    } finally {
      form.resetFields();
      setModalCreateAndEditVisible(false);
      fetchCategories();
      setButtonDisabled(true);
    }
  };

  const fetchCategoryById = async (id) => {
    setSelectId(id);
    try {
      const response = await api.get(`/service-categories/${id}`, {
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
          Authorization: `Bearer ${token}`,
        },
      });

      const categoryData = response.data;

      if (categoryData) {
        form.setFieldsValue({
          title: categoryData.title,
        });
      }
    } catch (err) {
      addToast({
        type: "error",
        title: intl.formatMessage({ id: "error" }),
        description: intl.formatMessage({
          id: "api.error." + err.response?.data?.description,
        }),
      });
    }
  };

  const updateCategory = async (values) => {
    try {
      await api.put(
        `/service-categories/${selectId}`,
        { title: values.title },
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "*/*",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      addToast({
        type: "success",
        title: intl.formatMessage({ id: "success" }),
        description: intl.formatMessage({ id: "success.category_update" }),
      });
    } catch (err) {
      addToast({
        type: "error",
        title: intl.formatMessage({ id: "error" }),
        description: intl.formatMessage({
          id: "api.error." + err.response?.data?.description,
        }),
      });
    } finally {
      form.resetFields();
      setModalCreateAndEditVisible(false);
      fetchCategories();
      setButtonDisabled(true);
      setisEditingCategory(false);
    }
  };

  const deleteCategory = async (id) => {
    try {
      await api.delete(`/service-categories/${id}`, {
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
          Authorization: `Bearer ${token}`,
        },
      });

      addToast({
        type: "success",
        title: intl.formatMessage({ id: "success" }),
        description: intl.formatMessage({ id: "success.category_delete" }),
      });
    } catch (err) {
      addToast({
        type: "error",
        title: intl.formatMessage({ id: "error" }),
        description: intl.formatMessage({
          id: "api.erro.-40001",
        }),
      });
    } finally {
      setModalDeleteVisible(false);
      fetchCategories();
    }
  };

  const fetchSubCategories = async (id) => {
    setLoadingTable(true);
    try {
      const response = await api.get(`/service-sub-categories/category/${id}`, {
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
          Authorization: `Bearer ${token}`,
        },
        params: {
          page: 0,
          size: 100,
          sortBy: "id",
        },
      });
      setSubCategories(response?.data?.subCategoryOutPutLists);
    } catch (err) {
      console.log(err);
    } finally {
      setLoadingTable(false);
    }
  };

  const insertSubCategory = async (values) => {
    try {
      await api.post(
        "/service-sub-categories",
        { title: values.titlenewsub, categoryId: selectId },
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "*/*",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      addToast({
        type: "success",
        title: intl.formatMessage({ id: "success" }),
        description: intl.formatMessage({ id: "success.subcategory_creation" }),
      });
    } catch (err) {
      addToast({
        type: "error",
        title: intl.formatMessage({ id: "error" }),
        description: intl.formatMessage({
          id: "api.error." + err.response?.data?.description,
        }),
      });
    } finally {
      form.resetFields();
      setModalCreateAndEditVisible(false);
      fetchSubCategories(selectId);
      setButtonDisabled(true);
    }
  };

  const fetchSubCategoryById = async (id) => {
    setSelectSubId(id);
    try {
      const response = await api.get(`/service-sub-categories/${id}`, {
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
          Authorization: `Bearer ${token}`,
        },
      });

      const categoryData = response.data;

      if (categoryData) {
        form.setFieldsValue({
          titlesub: categoryData.title,
        });
      }
    } catch (err) {
      addToast({
        type: "error",
        title: intl.formatMessage({ id: "error" }),
        description: intl.formatMessage({
          id: "api.error." + err.response?.data?.description,
        }),
      });
    }
  };

  const updateSubCategory = async (values) => {
    try {
      const response = await api.put(
        `/service-sub-categories/${selectSubId}`,
        {
          title: values.titlesub,
          categoryId: selectId,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "*/*",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      addToast({
        type: "success",
        title: intl.formatMessage({ id: "success" }),
        description: intl.formatMessage({ id: "success.subcategory_update" }),
      });

      return response.data;
    } catch (err) {
      addToast({
        type: "error",
        title: intl.formatMessage({ id: "error" }),
        description: intl.formatMessage({
          id: "api.error." + err.response?.data?.code,
        }),
      });
    } finally {
      form.resetFields();
      setModalCreateAndEditVisible(false);
      fetchSubCategories(selectId);
      setButtonDisabled(true);
      setisEditingSubCategory(false);
    }
  };

  const deleteSubcategory = async (id) => {
    try {
      await api.delete(`/service-sub-categories/${id}`, {
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
          Authorization: `Bearer ${token}`,
        },
      });

      addToast({
        type: "success",
        title: intl.formatMessage({ id: "success" }),
        description: intl.formatMessage({ id: "success.subcategory_delete" }),
      });
    } catch (err) {
      addToast({
        type: "error",
        title: intl.formatMessage({ id: "error" }),
        description: intl.formatMessage({
          id: "api.erro.-41001",
        }),
      });
    } finally {
      setModalDeleteVisible(false);
      fetchSubCategories(selectId);
    }
  };

  const handleSubmit = () => {
    const values = form.getFieldsValue();
    if (viewSubCategories) {
      if (isEditingSubCategory) {
        updateSubCategory(values);
      } else {
        insertSubCategory(values);
      }
    } else {
      if (isEditingCategory) {
        updateCategory(values);
      } else {
        insertCategory(values);
      }
    }
  };

  const handleEditing = (id) => {
    setModalCreateAndEditVisible(true);

    if (viewSubCategories) {
      fetchSubCategoryById(id);
      setisEditingSubCategory(true);
    } else {
      fetchCategoryById(id);
      setisEditingCategory(true);
    }
  };

  const handleDelete = (id, text) => {
    setModalDeleteVisible(true);

    if (viewSubCategories) {
      setSelectSubId(id);
      setSelectTitle(text);
    } else {
      setSelectId(id);
      setSelectTitle(text);
    }
  };

  const handleViewSubCategories = (id, title) => {
    setSelectTitle(title);
    setSelectId(id);
    fetchSubCategories(id);
    setViewSubCategories(true);
  };

  const handleCancelCategoryModal = () => {
    setModalCreateAndEditVisible(false);
    setisEditingCategory(false);
    setisEditingSubCategory(false);
    form.resetFields();
  };

  const columns = [
    {
      name: viewSubCategories
        ? intl.formatMessage({ id: "subcategory" })
        : intl.formatMessage({ id: "title" }),
      selector: (row) => row.title,
      sortable: true,
      sortFunction: (a, b) => a.title.localeCompare(b.title),
      cell: (row) => (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
            alignItems: "center",
          }}
        >
          <span>{row.title}</span>
          <Space>
            {!viewSubCategories && (
              <ButtonItens
                onClick={() => handleViewSubCategories(row.id, row.title)}
              >
                <IconItensDivMobile>
                  <EyeOutlined
                    style={{ fontSize: "16px", marginRight: "6px" }}
                  />
                </IconItensDivMobile>

                {intl.formatMessage({ id: "visualize" })}
              </ButtonItens>
            )}
            <ButtonItens onClick={() => handleEditing(row.id)}>
              <IconItensDivMobile>
                <EditOutlined
                  style={{ fontSize: "16px", marginRight: "6px" }}
                />
              </IconItensDivMobile>
              {intl.formatMessage({ id: "edit" })}
            </ButtonItens>
            <ButtonItens
              onClick={() => handleDelete(row.id, row.title)}
              style={{
                color: "rgba(153, 27, 27, 1)",
                background: "rgba(254, 202, 202, 1)",
                padding: "4px 8px",
                borderRadius: "4px",
              }}
            >
              <IconItensDivMobile>
                <DeleteOutlined
                  style={{ fontSize: "16px", marginRight: "6px" }}
                />
              </IconItensDivMobile>
              {intl.formatMessage({ id: "delete" })}
            </ButtonItens>
          </Space>
        </div>
      ),
    },
  ];

  const filteredCategories = categories?.filter((item) =>
    item.title?.toLowerCase().includes(searchTerm.toLowerCase())
  );
  const handleValuesChange = () => {
    const titleValue = form.getFieldValue("titlenewsub");
    setButtonDisabled(!titleValue || titleValue.trim() === "");
  };

  const handleBack = () => {
    if (viewSubCategories) {
      setViewSubCategories(false);
      setSelectSubId(null);
      setShouldGoBack(true);
    } else {
      history.goBack();
    }
  };
  const title = Form.useWatch("title", form);
  const titleSub = Form.useWatch("titleSub", form);

  return (
    <>
      <ModalCreateAndEdit
        title={(() => {
          switch (true) {
            case viewSubCategories && isEditingSubCategory:
              return intl.formatMessage({ id: "editing_subcategory" });
            case isEditingCategory:
              return intl.formatMessage({ id: "editing_category" });
            default:
              return intl.formatMessage({ id: "new_category" });
          }
        })()}
        closable={false}
        visible={ModalCreateAndEditVisible}
        footer={[
          <div
            style={{
              display: "flex",
              justifyContent: "end",
              gap: "15px",
              marginTop: "-40px",
              marginRight: "10px",
            }}
          >
            <ButtonItens onClick={() => handleCancelCategoryModal()}>
              <RiArrowGoBackLine
                style={{ fontSize: "16px", marginRight: "10px" }}
              />
              {intl.formatMessage({ id: "goback" })}
            </ButtonItens>
            <ButtonItens
              disabled={!viewSubCategories && !title?.trim() ? true : false}
              onClick={handleSubmit}
              style={{
                color: "rgba(255, 255, 255, 1)",
                background: "rgba(0, 34, 68, 1)",
              }}
            >
              <IconItensDiv>
                <FaRegSave
                  style={{
                    fontSize: "16px",
                    marginRight: "6px",
                  }}
                />
              </IconItensDiv>

              {intl.formatMessage({ id: "save" })}
            </ButtonItens>{" "}
          </div>,
        ]}
      >
        <Form form={form} layout="vertical">
          <FormItem
            label={
              <>
                {intl.formatMessage({ id: "title" })}
                <span
                  style={{
                    color: "rgba(98, 116, 142, 1)",
                    fontSize: "12px",
                    marginLeft: "3px",
                  }}
                >
                  {intl.formatMessage({ id: "up_to_50_characters" })}
                </span>
              </>
            }
            name={viewSubCategories ? "titlesub" : "title"}
            rules={[
              {
                required: true,
                message: intl.formatMessage({
                  id: "error.field_required",
                }),
              },
            ]}
          >
            <StyledInput maxLength={50} />
          </FormItem>
        </Form>
      </ModalCreateAndEdit>
      <ModalDelete
        closable={false}
        visible={ModalDeleteVisible}
        title={
          viewSubCategories
            ? `${intl.formatMessage({
                id: "want_to_delete_subcategory",
              })} "${selectTitle}" ?`
            : `${intl.formatMessage({
                id: "want_to_delete_category",
              })} "${selectTitle}" ?`
        }
        footer={[
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: "15px",
              marginTop: "-20px",
            }}
          >
            <ButtonDelete onClick={() => setModalDeleteVisible(false)}>
              <RiArrowGoBackLine
                style={{ fontSize: "16px", marginRight: "10px" }}
              />
              {intl.formatMessage({ id: "goback" })}
            </ButtonDelete>
            <ButtonDelete
              onClick={() =>
                viewSubCategories
                  ? deleteSubcategory(selectSubId)
                  : deleteCategory(selectId)
              }
              style={{
                color: "rgba(255, 255, 255, 1)",
                background: "rgba(153, 27, 27, 1)",
              }}
            >
              <FaRegTrashAlt
                style={{
                  fontSize: "16px",
                  marginRight: "6px",
                }}
              />
              {intl.formatMessage({ id: "delete" })}
            </ButtonDelete>
          </div>,
        ]}
      >
        <div style={{ display: "flex", justifyContent: "center" }}>
          {" "}
          <ModalSubtitle>
            {intl.formatMessage({ id: "warning_action_irresersible" })}
          </ModalSubtitle>
        </div>
      </ModalDelete>
      <AnimatedMainContainer
        breadcrumb={intl.formatMessage({ id: "sidebar.staff" })}
      >
        <Container>
          <TitleContainer>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Title>
                {viewSubCategories ? (
                  <>
                    <span style={{ fontWeight: "bold", marginRight: "20px" }}>
                      <FormattedMessage id="category" /> "{selectTitle}"
                    </span>
                  </>
                ) : (
                  <FormattedMessage id="categories" />
                )}
              </Title>
            </div>

            <GoBackContainer>
              <LinkButton onClick={() => handleBack()}>
                <Badge
                  color="#002244"
                  text={intl.formatMessage({ id: "goback" })}
                  fontSize="12px"
                />
              </LinkButton>
            </GoBackContainer>
          </TitleContainer>

          <Horizontal>
            <SearchContainer>
              <InputWrapper>
                {viewSubCategories ? (
                  <>
                    <Title>{intl.formatMessage({ id: "subcategory" })}</Title>
                    <Form
                      form={form}
                      layout="vertical"
                      onValuesChange={handleValuesChange}
                    >
                      <FormItem
                        label={
                          <>
                            {intl.formatMessage({ id: "title" })}
                            <span
                              style={{
                                color: "rgba(98, 116, 142, 1)",
                                fontSize: "12px",
                                marginLeft: "3px",
                              }}
                            >
                              {intl.formatMessage({
                                id: "up_to_50_characters",
                              })}
                            </span>
                          </>
                        }
                        name="titlenewsub"
                        rules={[
                          {
                            required: true,
                            message: intl.formatMessage({
                              id: "error.field_required",
                            }),
                          },
                        ]}
                      >
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <StyledInput maxLength={50} />
                          <ButtonAdd
                            disabled={buttonDisabled}
                            style={{
                              backgroundColor: "rgba(226, 232, 240, 1)",
                              color: "rgba(0, 34, 68, 1)",
                            }}
                            onClick={() => handleSubmit()}
                          >
                            {" "}
                            <PlusOutlined style={{ marginRight: "8px" }} />
                            {intl.formatMessage({ id: "add" })}
                          </ButtonAdd>
                        </div>
                      </FormItem>
                    </Form>
                  </>
                ) : (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <div style={{ width: "90%" }}>
                      <IconWrapper>
                        <SearchOutlined />
                      </IconWrapper>
                      <StyledInput
                        style={{ paddingLeft: "30px" }}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        placeholder={intl.formatMessage({ id: "search" })}
                      />
                    </div>

                    <ButtonAdd
                      onClick={() => setModalCreateAndEditVisible(true)}
                    >
                      {" "}
                      <PlusOutlined style={{ marginRight: "8px" }} />
                      {intl.formatMessage({ id: "new_category" })}
                    </ButtonAdd>
                  </div>
                )}
              </InputWrapper>
            </SearchContainer>
          </Horizontal>
        </Container>

        <Table
          staffCategory={viewSubCategories ? false : true}
          columns={columns}
          data={
            viewSubCategories
              ? Array.isArray(subCategories)
                ? subCategories
                : []
              : Array.isArray(filteredCategories)
              ? filteredCategories
              : []
          }
          progressPending={loadingTable}
          pagination
          paginationPerPage={10}
          paginationRowsPerPageOptions={[10, 15, 20, 25, 30]}
          highlightOnHover
          responsive
        />
      </AnimatedMainContainer>
    </>
  );
};

export default StaffCategories;
